import { Routes, mapToCanActivate } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { WithinCyclePerformanceOverviewComponent } from './components/within-cycle-performance-overview/within-cycle-performance-overview.component';

export const withinCyclePerformanceRoutes: Routes = [
  {
    path: 'within-cycle-performance',
    component: WithinCyclePerformanceOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    data: { name: 'within-cycle-performance-overview' },
  },
];
